// extracted by mini-css-extract-plugin
export var active = "_em-7";
export var container = "_em-0";
export var evenWidth = "_em-4";
export var large = "_em-5";
export var outlet = "_em-8";
export var slide = "_em-2";
export var small = "_em-6";
export var tab = "_em-3";
export var tabs = "_em-1";